import { render } from "./CurrentAffairsMonthPage.vue?vue&type=template&id=30cbe995&scoped=true"
import script from "./CurrentAffairsMonthPage.vue?vue&type=script&lang=js"
export * from "./CurrentAffairsMonthPage.vue?vue&type=script&lang=js"

import "./CurrentAffairsMonthPage.vue?vue&type=style&index=0&id=30cbe995&scoped=true&lang=css"

import exportComponent from "/var/www/html/bcsprostuti-web-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30cbe995"]])

export default __exports__